import { listPartner } from "./constants";

const localhost = {
  domain: ["localhost", "192.168.1.85"],
  partnerId: "nhidonghcm"
};

listPartner.push(localhost);

const removeWWW = () => {
  let domain = window.location.hostname.toLowerCase();
  domain = domain.replace("-beta", "");
  domain = domain.replace("www.", "");
  domain = domain.replace("medpro.vn", "medpro.com.vn");
  return domain;
};

const findPartnerByDomain = () => {
  console.log("removeWWW() :>> ", removeWWW());
  const { partnerId } = listPartner.find(i => i.domain.includes(removeWWW()));
  return partnerId;
};

export default findPartnerByDomain();
